import './CircularProgress.css'
export const CircularProgress = () => {
  return (
    <div className="loader"></div>
  )
}
